import r from "../managers/braze-instance.js";
import Z from "./content-cards-provider.js";
var rr = {
  i: !1,
  provider: null,
  o: function o() {
    return rr.t(), rr.provider || (rr.provider = new Z(r.ir(), r.p(), r.l(), r.tr(), r.m()), r.v(rr.provider)), rr.provider;
  },
  t: function t() {
    rr.i || (r.g(rr), rr.i = !0);
  },
  destroy: function destroy() {
    rr.provider = null, rr.i = !1;
  }
};
export default rr;